import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TaggedProducts from "./TaggedProducts"
export default function DialogTaggedProduct({ open, handleClose, fromAction }) {
    return (
        <div>
            <Dialog open={open} aria-labelledby="form-dialog-title" maxWidth="md" fullWidth>
                <DialogTitle id="form-dialog-title">{"Update"} Tagged Product Settings</DialogTitle>
                <DialogContent>
                    <TaggedProducts
                        handleClose={handleClose} />
                </DialogContent>
            </Dialog>
        </div >
    );
}